import { render, staticRenderFns } from "./ShareholdInformation.vue?vue&type=template&id=2470b832&scoped=true"
import script from "./ShareholdInformation.vue?vue&type=script&lang=js"
export * from "./ShareholdInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470b832",
  null
  
)

export default component.exports